export enum SyncStatus {
    Waiting,
    Processing,
    Success,
    Error
}